import { z } from "zod";
export const emailAddressSchema = z.email().max(254);
export const isValidEmailAddress = (value: string) => emailAddressSchema.safeParse(value).success;

export const sanitizeEmailInput = (value: string) => value.replace(/[^A-Za-z0-9.!#$%&'*+/=?^_`{|}~@-]/g, "").slice(0, 254);

export const sanitizeVerificationCodeInput = (value: string) => value.replace(/\D/g, "").slice(0, 6);
export const sanitizeDigitsInput = (value: string) => value.replace(/\D/g, "");

export const sanitizeLoginAccountInput = sanitizeEmailInput;
